import './owl.carousel.min.js'

$(document).ready(function() {
    // JS COMPRESS
    $(".owl-four").owlCarousel({
        margin: 200,
        loop: !0,
        autoplay: !0,
        autoplayTimeout: 4e3,
        autoplayHoverPause: !0,
        responsive: {
            0: {
                items: 1,
                nav: !1
            },
            600: {
                items: 1,
                nav: !1
            },
            1e3: {
                items: 1,
                nav: !1
            }
        }
    }), $(".owl-product").owlCarousel({
        loop: !0,
        margin: 10,
        nav: !0,
        responsive: {
            0: {
                items: 1,
                nav: !0
            },
            600: {
                items: 2,
                nav: !0
            },
            1e3: {
                items: 3,
                nav: !0
            }
        }
    });
    console.log("hi")
})
